import {
  LearningSectionContainerJsonModel
} from '../../learning-section-container/learning-section-container.json.model';

export namespace LearningSectionContainerActions {
  export class Add {
    static readonly type = getActionName('Add');
    constructor(readonly payload: LearningSectionContainerJsonModel) {}
  }

  export class AddRaw {
    static readonly type = getActionName('Add Raw');
    constructor(readonly payload: LearningSectionContainerJsonModel) {}
  }

  export class Edit {
    static readonly type = getActionName('Edit');
    constructor(readonly payload: LearningSectionContainerJsonModel) {}
  }

  export class EditRaw {
    static readonly type = getActionName('Edit Raw');
    constructor(readonly payload: LearningSectionContainerJsonModel) {}
  }

  export class Update {
    static readonly type = getActionName('Update');
    constructor(readonly payload: LearningSectionContainerJsonModel) {}
  }

  export class EditSingle {
    static readonly type = getActionName('Edit Single');
    constructor(readonly payload: LearningSectionContainerJsonModel) {}
  }

  export class Delete {
    static readonly type = getActionName('Delete');
    constructor(readonly payload: LearningSectionContainerJsonModel) {}
  }

  export class Fetch {
    static readonly type = getActionName('Fetch');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch success');
    constructor(readonly payload: LearningSectionContainerJsonModel[]) {}
  }

  export class FetchOne {
    static readonly type = getActionName('Fetch One');
    constructor(public id: string) {}
  }

  export class FetchOneSuccess {
    static readonly type = getActionName('Fetch One success');
    constructor(public payload: LearningSectionContainerJsonModel) {}
  }

  function getActionName(type: string) {
    return `[LearningSectionContainer] ${type}`;
  }
}
